export class AppUserAuth {
  userName: string = "";
  bearerToken: string = "";
  isAuthenticated: boolean = false;
  canAccessContent: boolean = false;
  canEditContent: boolean = false;
  canAccessData: boolean = false;
  canEditData: boolean = false;
}
